const Footer = () => (
  <footer>
    <p>Create your own upvote/downvote news aggregator!</p>
    <a href="/z">Get started</a>
  </footer>
);

export default Footer;
